import { observer } from 'mobx-react';
import React from 'react';

import Async from 'components/Async';
import DateRangePickerWithSearchParams from 'components/DatePicker/Range/WithSearchParams';
import GradeGrid from 'components/GradeGrid';

import { IStudentProgramModel } from '@common/models/StudentPrograms/StudentProgram';

import useGetGrades from './hooks/useGetGrades';
import * as Styled from './styled';

interface PropsType {
	programModel: IStudentProgramModel;
}

function ProgramGrades({ programModel }: PropsType) {
	const grades = useGetGrades(programModel.program_group_id);

	return (
		<Styled.Wrap>
			<Styled.Header>
				<DateRangePickerWithSearchParams />
			</Styled.Header>
			<Async loading={grades.loading}>
				<GradeGrid studentGrades={grades} programsIds={[programModel.program_group_id]} />
			</Async>
		</Styled.Wrap>
	);
}

export default observer(ProgramGrades);
